var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play-circle_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M.5 0h24v24H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.625v4.75c0 .367.158.633.475.8.317.167.625.15.925-.05l3.725-2.35A.873.873 0 0015.8 12a.873.873 0 00-.425-.775l-3.725-2.35a.848.848 0 00-.925-.05c-.317.167-.475.433-.475.8zM12.5 21.5a9.263 9.263 0 01-3.712-.75 9.58 9.58 0 01-3.013-2.025 9.58 9.58 0 01-2.025-3.013A9.263 9.263 0 013 12c0-1.317.25-2.554.75-3.713a9.583 9.583 0 012.025-3.012A9.58 9.58 0 018.788 3.25 9.263 9.263 0 0112.5 2.5a9.27 9.27 0 013.713.75 9.583 9.583 0 013.012 2.025 9.583 9.583 0 012.025 3.012A9.27 9.27 0 0122 12c0 1.317-.25 2.554-.75 3.712a9.58 9.58 0 01-2.025 3.013 9.583 9.583 0 01-3.012 2.025 9.27 9.27 0 01-3.713.75zm0-1.5c2.217 0 4.104-.779 5.663-2.337C19.721 16.104 20.5 14.217 20.5 12s-.779-4.104-2.337-5.663C16.604 4.779 14.717 4 12.5 4s-4.104.779-5.662 2.337C5.279 7.896 4.5 9.783 4.5 12s.78 4.104 2.338 5.663C8.396 19.221 10.283 20 12.5 20z",
    fill: "#fff"
  }))));
}
export default SvgPlayCircle;